var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","background-color":"var(--grey_alpha)"}},[_c('div',{staticClass:"view-content"},[(_vm.isMounted)?_c('concordance-request',{attrs:{"concordance-word":_vm.concordanceWord,"execute-on-mount":_vm.executeOnMount,"publication-year":_vm.publicationYear}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb58231","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Concordance.vue
// module id = null
// module chunks = 